// src/apiConfig.js
const API_URL = 'https://backend-ivc6.onrender.com/api';

export default API_URL;
